import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";

function normalizeUrl(value) {
  if (value === null || value === undefined) return "";
  const text = String(value).trim();
  return text.length ? text : "";
}

function getInitial(name) {
  const text = String(name || "").trim();
  if (!text) return "?";
  return text.charAt(0).toUpperCase();
}

const UserProfileAvatarWithFallback = ({
  picture,
  name,
  defaultUrl,
  t,
  alt,
  imageClassName,
  imageStyle,
  fallbackWrapperClassName,
  fallbackTextClassName,
  fallbackWrapperStyle,
  fallbackTextStyle,
}) => {
  const normalizedPicture = normalizeUrl(picture);
  const normalizedDefaultUrl = normalizeUrl(defaultUrl);

  const initialSrc = useMemo(() => {
    if (normalizedPicture && normalizedPicture !== normalizedDefaultUrl) {
      return normalizedPicture;
    }
    return normalizedDefaultUrl;
  }, [normalizedDefaultUrl, normalizedPicture]);

  const [currentSrc, setCurrentSrc] = useState(initialSrc);
  const [showFallback, setShowFallback] = useState(!initialSrc);

  useEffect(() => {
    setCurrentSrc(initialSrc);
    setShowFallback(!initialSrc);
  }, [initialSrc]);

  const handleImageError = () => {
    if (
      currentSrc === normalizedPicture &&
      normalizedDefaultUrl &&
      normalizedDefaultUrl !== normalizedPicture
    ) {
      setCurrentSrc(normalizedDefaultUrl);
      return;
    }
    setShowFallback(true);
  };

  if (showFallback || !currentSrc) {
    return (
      <div className={fallbackWrapperClassName} style={fallbackWrapperStyle}>
        <div className={fallbackTextClassName} style={fallbackTextStyle}>
          {getInitial(name)}
        </div>
      </div>
    );
  }

  return (
    <img
      src={currentSrc}
      className={imageClassName}
      style={imageStyle}
      alt={alt || (t && t("Photo de profil")) || "Photo de profil"}
      onError={handleImageError}
    />
  );
};

UserProfileAvatarWithFallback.propTypes = {
  picture: PropTypes.string,
  name: PropTypes.string,
  defaultUrl: PropTypes.string,
  t: PropTypes.func,
  alt: PropTypes.string,
  imageClassName: PropTypes.string,
  imageStyle: PropTypes.object,
  fallbackWrapperClassName: PropTypes.string,
  fallbackTextClassName: PropTypes.string,
  fallbackWrapperStyle: PropTypes.object,
  fallbackTextStyle: PropTypes.object,
};

UserProfileAvatarWithFallback.defaultProps = {
  picture: "",
  name: "",
  defaultUrl: "",
  t: null,
  alt: "",
  imageClassName: "avatar-xs rounded-circle",
  imageStyle: undefined,
  fallbackWrapperClassName: "flex-shrink-0 avatar-xs me-2",
  fallbackTextClassName: "avatar-title bg-soft-success text-success rounded-circle fs-13",
  fallbackWrapperStyle: undefined,
  fallbackTextStyle: undefined,
};

export default UserProfileAvatarWithFallback;
